import { render, staticRenderFns } from "./Battery.vue?vue&type=template&id=bb491f4e&scoped=true&"
import script from "./Battery.vue?vue&type=script&lang=js&"
export * from "./Battery.vue?vue&type=script&lang=js&"
import style0 from "./Battery.vue?vue&type=style&index=0&id=bb491f4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb491f4e",
  null
  
)

export default component.exports